import { Caption } from "@bounce/design-system"
import { useTranslation, useFormatYearDate } from "@bounce/i18n"

import type { NearbyStorageSpot } from "@/libs/bounce/stores/types"

import BadgeIcon from "@bounce/assets/icons/Badge.svg"

type StoreCardLiveSinceCaptionProps = Pick<NearbyStorageSpot, "firstLiveAt">

export const StoreCardLiveSinceCaption = ({ firstLiveAt }: StoreCardLiveSinceCaptionProps) => {
  const { t } = useTranslation()
  const formatDate = useFormatYearDate()

  if (!firstLiveAt) {
    return null
  }

  return (
    <span className="text-neutral-800">
      <BadgeIcon className="mr-1 inline-block size-4" />
      <Caption>
        {t("cmp.storeCard.liveSinceLabel", "On Bounce since {date}", { date: formatDate(firstLiveAt) })}
      </Caption>
    </span>
  )
}
